import {
  Asset as HygraphAsset,
  Maybe as HygraphMaybe,
  Scalars as HygraphScalars,
} from '@/lib/types';

import { HygraphImageProps } from '@/components/hygraph-image';

export default function hygraphImageTransformer(
  image: HygraphMaybe<HygraphAsset> | undefined,
  roundedCorners?: HygraphMaybe<HygraphScalars['Boolean']['output']>
): HygraphImageProps | undefined {
  if (!image) {
    return undefined;
  }

  return {
    url: image.url,
    description: image.description || undefined,
    height: image.height || 0,
    width: image.width || 0,
    roundedCorners: roundedCorners || false,
  };
}
